import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Bulletin } from '../models/Bulletin';
import { Etab } from '../models/Etab';
import { Period } from '../models/Period';
import { Results } from '../models/Results';
import { GroupResults } from '../models/GroupResults';
import { Categorie } from '../models/Categorie';

@Component({
  selector: 'app-page-ws',
  templateUrl: './page-ws.component.html',
  styleUrls: ['./page-ws.component.css']
})
export class PageWsComponent implements OnInit {

  constructor() {
  }

  innerWidth: number;
  per = 57.6;
  height = 0;
  width = 0;
  @Input() coef: number;
  @Input() period: Period;
  @Input() tools;
  bmodel = 'default';
  results: Results[] = [];
  apps: Results[] = [];
  total_note = 0;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
     const w = window.innerWidth;
     this.initHeight(w);
  }

  ngOnInit(): void {
    const w = window.innerWidth;
    this.initHeight(w);
  }

  @HostListener('window:changeHeight', ['$event'])
  changeHeight() {
     const w = window.innerWidth;
     this.initHeight(w);
     console.log("SCREEN: "+w);
  }

  initResults(bulletin) {
  bulletin.results.forEach(element => {
      if (element.cours.is_calc) {
         this.results.push(element);
        } else {
         this.apps.push(element);
      }
    });
  }
  parseInt(i) {
    return parseInt(i);
   }

  initHeight(screenWidth: number) {
    if(this.period && this.period.etab){
       const widthPageInPixel = (screenWidth * 62.8) / 100;
       this.period.pageWidth =  (this.period.widthb * this.period.etab.width)/100;
       this.period.pageHeight = (this.period.heightb * this.period.etab.height)/100;
    }
  }


  getTotalNote(bulletin) {
    let total = 0;
    for (const res of bulletin.results) {
      if (res.cours.is_calc && res.is_calc) {
          total += parseFloat(res.note);
       }
    }
    this.total_note = total;
    return total;
  }

  getResultsCalc(bulletin) {

    const results = [];
    bulletin.results.forEach(element => {
        if (element.cours.is_calc) {
            results.push(element);
        }
       });

    return this.groupResults(results);
  }

 groupResults(results: Results[]): GroupResults[] {
  const groupMap = new Map<string, Results[]>();

  for (const result of results) {
    const catCode = result.cours.cat_code;
    if (!groupMap.has(catCode)) {
      groupMap.set(catCode, []);
    }
    groupMap.get(catCode)!.push(result);
  }

  const groupResultsList: GroupResults[] = [];

  for (const [catCode, group] of groupMap.entries()) {
    const categorie = this.period.categories.find(item => item.code === catCode);
    const note = group.reduce((sum, res) => sum + res.note, 0);
    const groupResult = new GroupResults(catCode, categorie, group, note, categorie.note_total);
    groupResultsList.push(groupResult);
  }

  return groupResultsList;
}

  getResultsNonCalc(bulletin) {
    const results = [];
    bulletin.results.forEach(element => {
        if (!element.cours.is_calc) {
           results.push(element);
        }
       });
    return results;
  }
  delResults(iu, code) {
    // tslint:disable-next-line:prefer-for-of
     for (let i = 0; i < this.period.bulletins[iu].results.length; i++) {
       if (this.period.bulletins[iu].results[i].cours.code === code) {
          this.period.bulletins[iu].results.splice(i, 1);
          break;
       }
     }
  }

  // tslint:disable-next-line:variable-name
  getMoy(total_note, tnote, moy_total) {
    return ((total_note / tnote) * moy_total);
  }
}
